class K9FloatingStory extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready !== 'true') {
      this.dataset.ready = 'true';

      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-k9-story-open]');
      this.minimizeButton = this.querySelector('[data-k9-story-minimize]');
      this.restoreButton = this.querySelector('[data-k9-story-restore]');

      try {
        this.classList.toggle('is-compact', sessionStorage.getItem('k9FloatingStoryCompact') === '1');
      } catch (_error) {
        // Storage can be unavailable in privacy-restricted browser contexts.
      }

      this.openButton?.addEventListener('click', () => this.dialog?.showModal());
      this.minimizeButton?.addEventListener('click', () => this.setCompact(true));
      this.restoreButton?.addEventListener('click', () => this.setCompact(false));
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    this.observeFooter();
  }

  disconnectedCallback() {
    this.footerObserver?.disconnect();
  }

  observeFooter() {
    this.footerObserver?.disconnect();

    const footer = this.closest('.k9-footer');
    if (!footer || !('IntersectionObserver' in window)) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.classList.toggle('is-footer-visible', entry.isIntersecting);
    });
    this.footerObserver.observe(footer);
  }

  setCompact(compact) {
    this.classList.toggle('is-compact', compact);
    try {
      if (compact) sessionStorage.setItem('k9FloatingStoryCompact', '1');
      else sessionStorage.removeItem('k9FloatingStoryCompact');
    } catch (_error) {
      // Keep the visual toggle working even if storage is unavailable.
    }
  }
}

if (!customElements.get('k9-floating-story')) {
  customElements.define('k9-floating-story', K9FloatingStory);
}
